const addControlStyle: React.CSSProperties = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
};

export {
    addControlStyle,
}
